var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrameworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.37 106.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f1f2f2;\n        stroke: #bcbec0;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #414042;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.59,84.07l-8.47,2.59-4.57-14.93,14.93-4.57,2.59,8.47c1.09,3.57-.91,7.34-4.48,8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.85,84.3l-7.74,2.37-4.57-14.93,14.93-4.57,2.37,7.74c1.21,3.97-1.02,8.16-4.98,9.38h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.28,
    y: 74.38,
    width: 15.61,
    height: 15.61,
    transform: "translate(-20.5 27.32) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.28,
    y: 74.38,
    width: 15.61,
    height: 15.61,
    transform: "translate(-20.5 27.32) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.07,
    y: 79.65,
    width: 15.61,
    height: 15.61,
    transform: "translate(-22.79 22.52) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.86,
    y: 84.91,
    width: 15.61,
    height: 15.61,
    transform: "translate(-25.09 17.71) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.2,103.17l-7.75,2.37c-3.97,1.21-8.16-1.02-9.38-4.98l-2.37-7.74,14.93-4.57,4.57,14.93h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.23,
    y: 51.9,
    width: 15.61,
    height: 15.61,
    transform: "translate(-13.4 29.83) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.23,
    y: 51.9,
    width: 15.61,
    height: 15.61,
    transform: "translate(-13.4 29.83) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.01,
    y: 57.17,
    width: 15.61,
    height: 15.61,
    transform: "translate(-15.69 25.03) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.01,
    y: 57.17,
    width: 15.61,
    height: 15.61,
    transform: "translate(-15.69 25.03) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.8,
    y: 62.44,
    width: 15.61,
    height: 15.61,
    transform: "translate(-17.99 20.22) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.8,
    y: 62.44,
    width: 15.61,
    height: 15.61,
    transform: "translate(-17.99 20.22) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.59,
    y: 67.7,
    width: 15.61,
    height: 15.61,
    transform: "translate(-20.28 15.42) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.59,
    y: 67.7,
    width: 15.61,
    height: 15.61,
    transform: "translate(-20.28 15.42) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.38,
    y: 72.97,
    width: 15.61,
    height: 15.61,
    transform: "translate(-22.58 10.61) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.96,
    y: 34.69,
    width: 15.61,
    height: 15.61,
    transform: "translate(-8.59 27.54) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.96,
    y: 34.69,
    width: 15.61,
    height: 15.61,
    transform: "translate(-8.59 27.54) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.75,
    y: 39.96,
    width: 15.61,
    height: 15.61,
    transform: "translate(-10.89 22.73) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.75,
    y: 39.96,
    width: 15.61,
    height: 15.61,
    transform: "translate(-10.89 22.73) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.53,
    y: 45.22,
    width: 15.61,
    height: 15.61,
    transform: "translate(-13.18 17.93) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.32,
    y: 50.49,
    width: 15.61,
    height: 15.61,
    transform: "translate(-15.48 13.12) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.11,
    y: 55.76,
    width: 15.61,
    height: 15.61,
    transform: "translate(-17.77 8.32) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.69,
    y: 17.48,
    width: 15.61,
    height: 15.61,
    transform: "translate(-3.79 25.25) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.69,
    y: 17.48,
    width: 15.61,
    height: 15.61,
    transform: "translate(-3.79 25.25) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.48,
    y: 22.74,
    width: 15.61,
    height: 15.61,
    transform: "translate(-6.08 20.44) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.48,
    y: 22.74,
    width: 15.61,
    height: 15.61,
    transform: "translate(-6.08 20.44) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.27,
    y: 28.01,
    width: 15.61,
    height: 15.61,
    transform: "translate(-8.38 15.63) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.27,
    y: 28.01,
    width: 15.61,
    height: 15.61,
    transform: "translate(-8.38 15.63) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.05,
    y: 33.28,
    width: 15.61,
    height: 15.61,
    transform: "translate(-10.67 10.83) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.84,
    y: 38.54,
    width: 15.61,
    height: 15.61,
    transform: "translate(-12.96 6.02) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.98,13.25l-14.93,4.57-4.57-14.93L75.95,.3c3.57-1.09,7.34,.91,8.43,4.48l2.59,8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.98,13.25l-14.93,4.57-4.57-14.93,7.74-2.37c3.97-1.21,8.16,1.02,9.38,4.98l2.37,7.74h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 52.21,
    y: 5.53,
    width: 15.61,
    height: 15.61,
    transform: "translate(-1.28 18.14) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 52.21,
    y: 5.53,
    width: 15.61,
    height: 15.61,
    transform: "translate(-1.28 18.14) rotate(-17.01)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 10.8,
    width: 15.61,
    height: 15.61,
    transform: "translate(-3.57 13.34) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.79,
    y: 16.07,
    width: 15.61,
    height: 15.61,
    transform: "translate(-5.86 8.53) rotate(-17.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.13,34.32l-14.93,4.57L.83,31.14c-1.21-3.97,1.02-8.16,4.98-9.38l7.74-2.37,4.57,14.93h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameworkIcon);
export default __webpack_public_path__ + "static/media/frameworkIcon.a217f4a1cd76a4540fcc3daa64e3afbf.svg";
export { ForwardRef as ReactComponent };